import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const propTypes = {
    items: PropTypes.array.isRequired,
    onChangePage: PropTypes.func.isRequired,
    initialPage: PropTypes.number
};

const defaultProps = {
    initialPage: 1
};

/**
 * Source: {@link http://jasonwatmore.com/post/2017/03/14/react-pagination-example-with-logic-like-google}
 */
class PaginationController extends React.Component {
    constructor(props) {
        super(props);
        this.state = { pager: {} };
    }

    componentWillMount() {
        // set page if items array isn't empty
        if (this.props.items && this.props.items.length) {
            this.setPage(this.props.initialPage);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        // reset page if items array has changed
        if (prevProps.items !== this.props.items) {
            this.setPage(this.props.initialPage);
        }
    }

    setPage(page) {
        const items = this.props.items;
        let pager = {};

        if (page < 1 || page > pager.totalPages) {
            return;
        }

        // get new pager object for specified page
        pager = this.getPager(items.length, page);

        // get new page of items from items array
        const pageOfItems = items.slice(pager.startIndex, pager.endIndex + 1);

        // update state
        this.setState({ pager: pager });

        // call change page function in parent component
        this.props.onChangePage(pageOfItems);
    }

    getPager(totalItems, currentPage, pageSize) {
        // default to first page
        currentPage = currentPage || 1;

        // default page size is 12
        pageSize = pageSize || 12;

        // calculate total pages
        let totalPages = Math.ceil(totalItems / pageSize);

        let startPage, endPage;
        if (totalPages <= 10) {
            // less than 10 total pages so show all
            startPage = 1;
            endPage = totalPages;
        } else {
            // more than 10 total pages so calculate start and end pages
            if (currentPage <= 6) {
                startPage = 1;
                endPage = 10;
            } else if (currentPage + 4 >= totalPages) {
                startPage = totalPages - 9;
                endPage = totalPages;
            } else {
                startPage = currentPage - 5;
                endPage = currentPage + 4;
            }
        }

        // calculate start and end item indexes
        let startIndex = (currentPage - 1) * pageSize;
        let endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

        // create an array of pages to ng-repeat in the pager control
        let pages = _.range(startPage, endPage + 1);

        // return object with all pager properties required by the view
        return {
            totalItems: totalItems,
            currentPage: currentPage,
            pageSize: pageSize,
            totalPages: totalPages,
            startPage: startPage,
            endPage: endPage,
            startIndex: startIndex,
            endIndex: endIndex,
            pages: pages
        };
    }

    render() {
        let pager = this.state.pager;
        const disableFirstAndPrevious = pager.currentPage <= 1;
        const disableLastAndNext = pager.currentPage >= pager.totalPages;

        return (
            <div
                style={{
                    margin: '15px auto',
                    display: 'inline-block',
                    width: 'inherit',
                    textAlign: 'center'
                }}
            >
                {
                    !this.props.isTypingInSearchBar &&
                    <div className="mb-2">{this.state.pager.totalItems || 0} items displayed</div>
                }
                {
                    // don't display pager if there is only 1 page
                    (pager.pages && pager.pages.length > 1) &&
                    <div className="btn-group btn-group-sm mb-2">
                        <div className={"btn btn-outline-dark" + (disableFirstAndPrevious ? " disabled" : "")} onClick={() => {if (!disableFirstAndPrevious) {this.setPage(1);}}}>First</div>
                        <div className={"btn btn-outline-dark" + (disableFirstAndPrevious ? " disabled" : "")} onClick={() => {if (!disableFirstAndPrevious) {this.setPage(pager.currentPage - 1);}}}>Previous</div>
                        {
                            pager.pages.map((page, index) =>
                                <div
                                    key={index}
                                    className={"btn " + (pager.currentPage === page ? "btn-dark" : "btn-outline-dark")}
                                    onClick={() => this.setPage(page)}
                                >
                                    {page}
                                </div>
                            )
                        }
                        <div className={"btn btn-outline-dark" + (disableLastAndNext ? " disabled" : "")} onClick={() => {if (!disableLastAndNext) {this.setPage(pager.currentPage + 1);}}}>Next</div>
                        <div className={"btn btn-outline-dark" + (disableLastAndNext ? " disabled" : "")} onClick={() => {if (!disableLastAndNext) {this.setPage(pager.totalPages);}}}>Last</div>
                    </div>
                }
            </div>
        );
    }
}

PaginationController.propTypes = propTypes;
PaginationController.defaultProps = defaultProps;
export default PaginationController;


// WEBPACK FOOTER //
// ./src/components/unit/recordings/search/PaginationController.jsx